<template>
  <div>
    <el-row type="flex" justify="end" class="desc-table-top">
        <el-button v-if="showExcelHeader" size="small" style="margin-right: 2px;" @click="onClickExportExcel"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
      <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </el-row>
    <el-row>
      <el-table-wrapper ref="datacenterTable" border :data="tableDatas" :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool" :show-overflow-tooltip="true"
      :pagination="true" :remote="true" :total="tableTotal" :column-default="columnDefault" @condition-change="onChangeTable">
      </el-table-wrapper>
    </el-row>
  </div>
</template>

<script>
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import { columnDefault } from '@/constants/table';
import { mapGetters } from 'vuex';
import { isNil } from 'lodash';
import perfApi from '@/api/virtual/performance/config';

export default {
  name: 'WDataCenterPerfTable',
  props: {
    active: {
      type: Boolean,
      default: () => false,
    },
    showExcelHeader: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      params: {
        objtypeIds: ['VDC'],
      },
      tableDatas: [],
      columnDefault,
      tableTotal: 0,
      showSearchTool: false,
      columns: [
        { label: '데이터센터 명', prop: 'objName', remoteProp: 'objName', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { label: '호스트 클러스터 수', prop: 'VDC_COMMON/HOST_CLUSTER_COUNT', remoteProp: 'VDC_COMMON/HOST_CLUSTER_COUNT', formatter: this.getTableValueAfterCheckEmpty },
        { label: '호스트 수', prop: 'VDC_COMMON/HOST_COUNT', remoteProp: 'VDC_COMMON/HOST_COUNT', formatter: this.getTableValueAfterCheckEmpty },
        { label: 'VM 수', prop: 'VDC_COMMON/VM_COUNT', remoteProp: 'VDC_COMMON/VM_COUNT', formatter: this.getTableValueAfterCheckEmpty },
        { label: '스토리지 클러스터 수', prop: 'VDC_COMMON/STORAGE_CLUSTER_COUNT', remoteProp: 'VDC_COMMON/STORAGE_CLUSTER_COUNT', formatter: this.getTableValueAfterCheckEmpty },
        { label: '스토리지 수', prop: 'VDC_COMMON/STORAGE_COUNT', remoteProp: 'VDC_COMMON/STORAGE_COUNT', formatter: this.getTableValueAfterCheckEmpty },
      ],
      EMPTY_TEXT,
    };
  },
  computed: {
    ...mapGetters(['selectedNode', 'selectedObjDefineIds']),
    treeType() {
      return this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
    },
  },
  watch: {
    selectedNode: {
      handler() {
        if (this.$refs.datacenterTable === undefined) {
          this.$nextTick(() => {
            this.loadStore();
          });
        } else {
          this.loadStore();
        }
      },
      immediate: true,
    },
    active: {
      handler() {
        this.loadStore();
      },
    },
  },
  methods: {
    loadStore() {
      if (this.active) {
        const tableParams = this.$refs.datacenterTable.getParameter();
        const params = {
          ...tableParams,
          isGroup: true,
          treeType: this.treeType,
          subType: this.selectedNode.subType,
          hypervisorType: this.selectedNode.hypervisorType,
          objId: this.selectedNode.obj ? this.selectedNode.obj.objId : null,
          virtualcenterGroupId: this.selectedNode.virtualcenterGroupId,
          objtypeId: this.selectedNode.obj ? this.selectedNode.obj.objtypeId : this.selectedNode.objtypeId,
          objtypeIds: ['VDC'],
        };
        perfApi.getGroupConfigInfoForObjtype(params).then((response) => {
          if (response.data.success) {
            this.tableDatas = response.data.data;
            this.tableTotal = response.data.total;
          }
        });
      }
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    onChangeTable() {
      this.loadStore();
    },
    convertValue(value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, null);
    },
    // 장비 목록 엑셀 출력
    onClickExportExcel() {
      const params = {
        treeType: this.treeType,
        subType: this.selectedNode.subType,
        hypervisorType: this.selectedNode.hypervisorType,
        objId: this.selectedNode.obj ? this.selectedNode.obj.objId : null,
        virtualcenterGroupId: this.selectedNode.virtualcenterGroupId,
        managegroupIds: this.selectedNode.managegroupId ? this.selectedNode.childManagegroupIds : null,
        objtypeId: this.selectedNode.obj ? this.selectedNode.obj.objtypeId : this.selectedNode.objtypeId,
        objtypeIds: ['VDC'],
        isGroup: true,
      };
      perfApi.exportVmsConfigInfoTargetDeviceList(params);
    },
    convertValuByUnit,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/components/virtual/DataCenterPerfTable.vue